import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { locations } from '../mocks/locations';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Packages = lazy(() => import('../pages/packages/page'));
const Gallery = lazy(() => import('../pages/gallery/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Locations = lazy(() => import('../pages/locations/page'));
const LocationPage = lazy(() => import('../pages/locations/LocationPage'));
const Terms = lazy(() => import('../pages/terms/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const ThankYou = lazy(() => import('../pages/thank-you/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/packages',
    element: <Packages />,
  },
  {
    path: '/gallery',
    element: <Gallery />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/thank-you',
    element: <ThankYou />,
  },
  {
    path: '/locations',
    element: <Locations />,
  },
  {
    path: '/terms-of-service',
    element: <Terms />,
  },
  {
    path: '/privacy-policy',
    element: <Privacy />,
  },
  // Individual location routes
  ...locations.map((location) => ({
    path: `/locations/${location.slug}`,
    element: <LocationPage locationData={location} />,
  })),
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
